import { MessagesPanel } from '../messaging/MessagesPanel';

/** Teacher → Messages tab. Compact list layout for mobile. */
export function TeacherMessagesPage() {
  return <MessagesPanel title="Messages" compact />;
}
